export default "__VITE_ASSET__286f2bd4__"